import React, { useEffect, useState } from 'react';
import { GridController, GridTable } from '@ctsu/ctsu-mui-grid';
import PropTypes from 'prop-types';
import { GetUserFullName, useGetPathProtocol } from 'helpers';
import { TE } from 'appconstants';
import { PSRInfoColumns } from '../gridcolumns';

const STATUS_FILTER = 'ACTIVE,PROPOSED';
const controller = GridController.createController();

const PSRInfo = ({
  data,
  maxPsrId,
  minPsrId,
  onRowClicked,
  changeSequence,
  highlightObj,
  setHighlighted,
  onDataLoad
}) => {
  const protocolNumber = useGetPathProtocol();
  const [filterObj, setFilterObj] = useState({ esysStatus: STATUS_FILTER });

  useEffect(() => {
    controller.filterExternally(filterObj, true, false);
  }, [filterObj]);

  return <GridTable
    tag={`${TE.ID}psrinformation${TE.TABLE}`}
    title="PSR Information"
    controller={controller}
    exportTitle={`PSR Information-${protocolNumber}-PSR`}
    columns={PSRInfoColumns}
    user={GetUserFullName()}
    rows={data}
    editable
    deletable
    filterable
    sortable
    enableToolbar
    recordPerPage={100}
    rowsPerPageOptions={[50, 75, 100]}
    onDataLoad={onDataLoad}
    rowEvents={[minPsrId, maxPsrId, changeSequence]}
    highlightRowObject={highlightObj}
    filterState={{ esysStatus: STATUS_FILTER }}
    nonExportable={['displayStatus']}
    onClearFilter = {
      () => {
        controller.filterExternally({esysStatus: STATUS_FILTER}, true, false);
      }
    }
    onFilter={(object, field) => {
      setHighlighted(field);
      setFilterObj((prevFilter) => {
        const lastFilter = { ...prevFilter };
        lastFilter[field.field] = field.value;
        return {
          ...lastFilter
        };
      });
    }}
    onRowClicked={onRowClicked}
    toPdf={false}
  />
};

PSRInfo.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array]),
  onRowClicked: PropTypes.func.isRequired,
  changeSequence: PropTypes.func.isRequired
};

PSRInfo.defaultProps = {
  data: null
};

export { PSRInfo };
